module.exports = __webpack_public_path__ + "media/images/features/3/studio-1-cad089c597fdcecb34e75c86ca5d1577.jpg";